import { handleActions } from 'redux-actions';

import { siteEmailRecipientsSuccess, siteEmailSettingsSuccess } from './actions';

import initialState from './states';
import { logoutSuccess } from 'ducks/auth/actions';

export default handleActions(
  {
    [siteEmailSettingsSuccess](state, { payload: { siteID, settings } }) {
      return {
        ...state,
        settings: {
          ...state.settings,
          [siteID]: settings,
        },
      };
    },
    [siteEmailRecipientsSuccess](state, { payload: { recipients } }) {
      return {
        ...state,
        recipients,
      };
    },
    [logoutSuccess]() {
      return initialState;
    },
  },
  initialState
);
